import React, { lazy, useEffect } from "react";
import {
  FaTools, FaEdit, FaChartBar, FaBox, FaList, FaRuler, FaPlus,
  FaTags, FaTag, FaBarcode, FaBoxes, FaCashRegister, FaFileInvoiceDollar,
  FaUsers, FaUserPlus, FaTruck, FaTruckLoading, FaShoppingCart,
  FaBuilding, FaUserTie, FaPlusCircle, FaMoneyBillWave, FaMoneyCheck,
  FaUserEdit, FaUsersCog, FaUserShield, FaSignInAlt, FaBan, FaHistory, FaShieldAlt, FaClock, FaHandHoldingHeart,
  FaDatabase, FaServer, FaRobot, FaWrench
} from 'react-icons/fa';


import SideBar from "../../modules/core/components/SideBar/SideBar";
import NavBar from "../../modules/core/components/NavBar/NavBar";
import Footer from "../../modules/core/components/footer/Footer";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "../../modules/auth/PrivateRoute";
// NEW PROCUREMENT MODULES
import ProcurementDashboard from '../../modules/purchases/ProcurementDashboard';
import UnifiedPurchaseForm from '../../modules/purchases/UnifiedPurchaseForm';

const Icons = {
  FaTools, FaEdit, FaChartBar, FaBox, FaList, FaRuler, FaPlus,
  FaTags, FaTag, FaBarcode, FaBoxes, FaCashRegister, FaFileInvoiceDollar,
  FaUsers, FaUserPlus, FaTruck, FaTruckLoading, FaShoppingCart,
  FaBuilding, FaUserTie, FaPlusCircle, FaMoneyBillWave, FaMoneyCheck,
  FaUserEdit, FaUsersCog, FaUserShield, FaSignInAlt, FaBan, FaHistory, FaShieldAlt, FaClock, FaDatabase, FaServer, FaRobot, FaWrench
};

// Lazy load all module components for performance optimization
const Dashboard = lazy(() => import('../../modules/dashboard/components/DashboardPortal'));
const ItemForm = lazy(() => import('../../modules/items/itemsList/ItemForm'));
const AddItems = lazy(() => import('../../modules/items/AddItems'));
const ItemList = lazy(() => import('../../modules/items/itemsList/ItemList'));
const SupplierForm = lazy(() => import('../../modules/suppliers/SupplierForm'));
const SupplierManagement = lazy(() => import('../../modules/suppliers/SupplierManagement'));
const SupplierList = lazy(() => import('../../modules/suppliers/SupplierList'));
const AccountList = lazy(() => import('../../modules/accounts/AccountList'));
const CompanyProfile = lazy(() => import('../../modules/company/CompanyProfile'));
const CompanyForm = lazy(() => import('../../modules/company/CompanyForm'));
const CustomerForm = lazy(() => import('../../modules/customers/CustomerForm'));
const CustomerList = lazy(() => import('../../modules/customers/CustomerList'));
const CustomersAccountList = lazy(() => import('../../modules/accounts/CustomersAccountList'));
const SuppliersAccountList = lazy(() => import('../../modules/accounts/SuppliersAccountList'));
const BrandList = lazy(() => import('../../modules/brand/BrandList'));
const BrandForm = lazy(() => import('../../modules/brand/BrandForm'));
const UnitForm = lazy(() => import('../../modules/units/UnitForm'));
const UnitTable = lazy(() => import('../../modules/units/UnitTable'));
const EmployeeForm = lazy(() => import('../../modules/employee/EmployeeForm'));
const EmployeeList = lazy(() => import('../../modules/employee/EmployeeList'));
const EmployeeAccountList = lazy(() => import('../../modules/accounts/EmployeeAccountList'));
const BarcodePrinter = lazy(() => import('../../modules/barcode/BarcodePrinter'));
const PaymentForm = lazy(() => import('../../modules/payments/PaymentForm'));
const StockDashboard = lazy(() => import('../../modules/stock/StockDashboard'));
const POSLayout = lazy(() => import('../../modules/pos/POSLayout'));
const BarcodeTemplateManager = lazy(() => import('../../modules/barcode/template/BarcodeTemplateManager'));
const UserList = lazy(() => import('../../modules/users/UserList'));
const InvoicesTable = lazy(() => import('../../modules/sales/InvoicesTable'));
const PermissionManager = lazy(() => import('../../modules/PermissionManager/PermissionManager'));
const LoginForm = lazy(() => import('../../modules/auth/Login'));
const UnauthorizedPage = lazy(() => import('../../modules/core/components/Unauthorized/UnauthorizedPage'));
const PurchaseOrderList = lazy(() => import('../../modules/purchase/PurchaseOrderList'));
const PaymentTransactionList = lazy(() => import('../../modules/payments/PaymentTransactionList'));
const AccountForm = lazy(() => import('../../modules/accounts/AccountForm'));
const DeviceCreationForm = lazy(() => import('../../modules/device/DeviceCreationForm'));
const DeviceInspectionChecklist = lazy(() => import('../../modules/device/DeviceInspectionChecklist'));
const TicketForm = lazy(() => import('../../modules/ticket/TicketForm'));
const PhoneModelTable = lazy(() => import('../../modules/phone-models/PhoneModelTable'));
const ServiceItemForm = lazy(() => import('../../modules/serviceItems/ServiceItemForm'));
const ServiceManager = lazy(() => import('../../modules/serviceItems/ServiceManager'));
const PhoneModelManager = lazy(() => import('../../modules/phone-models/PhoneModelManager'));
const ReportedIssuesManager = lazy(() => import('../../modules/ReportedIssue/ReportedIssuesManager'));
const TicketManager = lazy(() => import('../../modules/ticket/TicketManager'));
const StockReportOverview = lazy(() => import('../../modules/reports/stocks/StockReportOverview'));
const UserProfile = lazy(() => import('../../modules/users/UserProfile'));
const DeviceCheckIn = lazy(() => import('../../modules/repair/components/DeviceCheckIn/DeviceCheckIn'));
const RepairDashboard = lazy(() => import('../../modules/repair/components/Dashboard/RepairDashboard'));
const RepairList = lazy(() => import('../../modules/repair/pages/RepairList'));
const RepairIntake = lazy(() => import('../../modules/repair/pages/RepairIntake'));
const QuickServiceManager = lazy(() => import('../../modules/repair/pages/QuickServiceManager'));
const WarrantyList = lazy(() => import('../../modules/warranty/WarrantyList'));
const ReplacementTransactions = lazy(() => import('../../modules/warranty/ReplacementTransactions'));
const PurchaseReturnList = lazy(() => import('../../modules/purchase/PurchaseReturnList'));
const StockMovementDashboard = lazy(() => import('../../modules/stock/StockMovementDashboard'));
const StockAdjustmentList = lazy(() => import('../../modules/stock/StockAdjustmentList'));
const ReportsPortal = lazy(() => import('../../modules/reports/ReportsPortal'));
const ProfitLossReport = lazy(() => import('../../modules/reports/profitLoss/ProfitLossReport'));
const ShiftManagement = lazy(() => import('../../modules/Shift/ShiftManagement'));
const ProductCatalog = lazy(() => import('../../modules/items/ProductCatalog'));
const InvoiceSettings = lazy(() => import('../../modules/settings/InvoiceSettings'));
const AttributeManager = lazy(() => import('../../modules/items/AttributeManager'));
const PolicyManager = lazy(() => import('../../modules/warranty/PolicyManager'));
const CustomerDeviceHub = lazy(() => import('../../modules/warranty/CustomerDeviceHub'));
const SystemUsage = lazy(() => import('../../modules/settings/SystemUsage'));
const GhostItemDetection = lazy(() => import('../../modules/settings/GhostItemDetection'));
const ZakatManager = lazy(() => import('../../modules/zakat/ZakatManager'));
const BatchPriceUpdater = lazy(() => import('../../modules/stock/BatchPriceUpdater'));
const BatchNumberPriceUpdater = lazy(() => import('../../modules/stock/BatchNumberPriceUpdater'));
const StockDamageManager = lazy(() => import('../../modules/stock/StockDamageManager'));
const AdminQuotaHub = lazy(() => import('../../admin-portal/quota-hub/QuotaHub'));
const TenantRegistry = lazy(() => import('../../admin-portal/tenant-registry/TenantRegistry'));
const ExpenseManagement = lazy(() => import('../../modules/accounts/ExpenseManagement'));
const SystemActivityLogs = lazy(() => import('../../modules/system/SystemActivityLogs'));





export const ROUTE_CONFIG = [
  // Repair Module
  {
    path: '/repairs',
    component: RepairList,
    module: 'dashboard',
    actions: ['view'],
    icon: Icons.FaTools,
    label: 'Repairs List',
    group: 'repair'
  },
  {
    path: '/repairs/new',
    component: RepairIntake,
    module: 'dashboard',
    actions: ['view', 'create'],
    icon: Icons.FaPlus,
    label: 'New Repair',
    group: 'repair'
  },
  {
    path: '/quick-services',
    component: QuickServiceManager,
    module: 'dashboard',
    actions: ['view', 'edit'],
    icon: Icons.FaWrench,
    label: 'Quick Services',
    group: 'repair'
  },
  // Dashboard
  {
    path: '/',
    component: Dashboard,
    module: 'dashboard',
    actions: ['view'],
    icon: Icons.FaChartBar,
    label: 'Dashboard'
  },
  // Inventory Management
  {
    path: '/ProductCatalog',
    component: ProductCatalog,
    module: 'items',
    actions: ['view'],
    icon: Icons.FaList,
    label: 'Product Catalog',
    group: 'inventory'
  },
  {
    path: '/AddItems',
    component: ItemForm,
    module: 'items',
    actions: ['create'],
    icon: Icons.FaBox,
    label: 'Add Item',
    group: 'inventory'
  },
  {
    path: '/ListItems',
    component: ItemList,
    module: 'items',
    actions: ['view'],
    icon: Icons.FaList,
    label: 'Items List',
    group: 'inventory'
  },
  {
    path: '/ListUnits',
    component: UnitTable,
    module: 'units',
    actions: ['view'],
    icon: Icons.FaRuler,
    label: 'Units List',
    group: 'inventory'
  },
  {
    path: '/AddUnits',
    component: UnitForm,
    module: 'units',
    actions: ['create'],
    icon: Icons.FaPlus,
    label: 'Add Unit',
    group: 'inventory'
  },
  {
    path: '/ListAllBrands',
    component: BrandList,
    module: 'items',
    actions: ['view'],
    icon: Icons.FaTags,
    label: 'Brands',
    group: 'inventory'
  },
  {
    path: '/AddBrand',
    component: BrandForm,
    module: 'items',
    actions: ['create'],
    icon: Icons.FaTag,
    label: 'Add Brand',
    group: 'inventory'
  },
  {
    path: '/Attributes',
    component: AttributeManager,
    module: 'items',
    actions: ['view', 'edit'],
    icon: Icons.FaTag,
    label: 'Attributes',
    group: 'inventory'
  },

  {
    path: '/LabelPrint',
    component: BarcodePrinter,
    module: 'barcode',
    actions: ['view'],
    icon: Icons.FaBarcode,
    label: 'Print Labels',
    group: 'inventory'
  },
  {
    path: '/BarcodeTemplateManager',
    component: BarcodeTemplateManager,
    module: 'barcode',
    actions: ['edit'],
    icon: Icons.FaBarcode,
    label: 'Barcode Templates',
    group: 'inventory'
  },
  {
    path: '/StockOverview',
    component: StockDashboard,
    module: 'stock',
    actions: ['view'],
    icon: Icons.FaBoxes,
    label: 'Stock Overview',
    group: 'inventory'
  },
  {
    path: '/StockValuations',
    component: React.lazy(() => import('../../modules/stock/StockValuation')),
    module: 'stock',
    actions: ['view'],
    icon: Icons.FaChartLine,
    label: 'Stock Valuations',
    group: 'inventory'
  },
  {
    path: '/StockMovement',
    component: StockMovementDashboard,
    module: 'stock',
    actions: ['view'],
    icon: Icons.FaChartBar,
    label: 'Stock Movement',
    group: 'inventory'
  },
  {
    path: '/virtual-warehouse',
    component: lazy(() => import('../../modules/inventory/VirtualWarehouseHub')),
    module: 'stock',
    actions: ['view'],
    icon: Icons.FaBoxes,
    label: 'Virtual Warehouse',
    group: 'inventory'
  },
  {
    path: '/StockAdjustments',
    component: StockAdjustmentList,
    module: 'stock',
    actions: ['view'],
    icon: Icons.FaHistory,
    label: 'Adjustment List',
    group: 'inventory'
  },
  {
    path: '/BatchPriceUpdate',
    component: BatchPriceUpdater,
    module: 'stock',
    actions: ['edit'],
    icon: Icons.FaTags,
    label: 'Batch Price Update',
    group: 'inventory'
  },
  {
    path: '/BatchNumberPriceUpdate',
    component: BatchNumberPriceUpdater,
    module: 'stock',
    actions: ['edit'],
    icon: Icons.FaTags,
    label: 'Batch No. Price Update',
    group: 'inventory'
  },
  {
    path: '/StockDamageManager',
    component: StockDamageManager,
    module: 'stock',
    actions: ['edit'],
    icon: Icons.FaBan,
    label: 'Stock Damage & Write-Off',
    group: 'inventory'
  },

  // Sales & POS
  {
    path: '/posOpen',
    component: POSLayout,
    module: 'pos',
    actions: ['view', 'create'],
    icon: Icons.FaCashRegister,
    label: 'POS',
    group: 'sales'
  },
  {
    path: '/AllSales',
    component: InvoicesTable,
    module: 'sales',
    actions: ['view'],
    icon: Icons.FaFileInvoiceDollar,
    label: 'Sales History',
    group: 'sales'
  },
  {
    path: '/warranties',
    component: WarrantyList,
    module: 'dashboard',
    actions: ['view'],
    icon: Icons.FaTools, // Or Icons.FaShieldAlt if I had it in Icons map, using FaTools for now as it's similar
    label: 'Warranties',
    group: 'sales'
  },
  {
    path: '/replacement-audit',
    component: ReplacementTransactions,
    module: 'dashboard',
    actions: ['view'],
    icon: Icons.FaExchangeAlt,
    label: 'Replacement Audit',
    group: 'sales'
  },

  // Customers
  {
    path: '/ListAllCustomers',
    component: CustomerList,
    module: 'customers',
    actions: ['view'],
    icon: Icons.FaUsers,
    label: 'Customers List',
    group: 'customers'
  },
  {
    path: '/AddCustomer',
    component: CustomerForm,
    module: 'customers',
    actions: ['create'],
    icon: Icons.FaUserPlus,
    label: 'Add Customer',
    group: 'customers'
  },

  // Suppliers
  {
    path: '/ListAllSuppliers',
    component: SupplierList,
    module: 'supplier',
    actions: ['view'],
    icon: Icons.FaTruck,
    label: 'Suppliers List',
    group: 'customers'
  },
  {
    path: '/AddSupplier',
    component: SupplierForm,
    module: 'supplier',
    actions: ['create'],
    icon: Icons.FaTruckLoading,
    label: 'Add Supplier',
    group: 'suppliers'
  },
  {
    path: '/ProcurementCenter',
    component: ProcurementDashboard,
    module: 'purchase',
    actions: ['view'],
    icon: Icons.FaShoppingCart,
    label: 'Procurement Center',
    group: 'purchase'
  },
  {
    path: '/purchases/new',
    component: UnifiedPurchaseForm,
    module: 'purchase',
    actions: ['create'],
    icon: Icons.FaPlus,
    label: 'New Purchase',
    group: 'purchase',
    hidden: true
  },
  {
    path: '/ListPurchase',
    component: PurchaseOrderList,
    module: 'purchase',
    actions: ['view'],
    icon: Icons.FaShoppingCart,
    label: 'Purchase Orders',
    group: 'purchase'
  },
  {
    path: '/purchase-returns',
    component: lazy(() => import('../../modules/inventory/VirtualWarehouseHub')),
    module: 'purchase',
    actions: ['view'],
    icon: Icons.FaHistory,
    label: 'Supplier Returns (Virtual Warehouse)',
    group: 'purchase'
  },

  // Accounts & Payments
  {
    path: '/ListCompanyAccounts',
    component: AccountList,
    module: 'companyAccount',
    actions: ['view'],
    icon: Icons.FaBuilding,
    label: 'Company Accounts',
    group: 'accounts'
  },
  {
    path: '/ListCustomersAccounts',
    component: CustomersAccountList,
    module: 'customersAccount',
    actions: ['view'],
    icon: Icons.FaUserTie,
    label: 'Customer Accounts',
    group: 'accounts'
  },
  {
    path: '/ListSuppliersAccounts',
    component: SuppliersAccountList,
    module: 'supplierAccount',
    actions: ['view'],
    icon: Icons.FaTruck,
    label: 'Supplier Accounts',
    group: 'accounts'
  },
  {
    path: '/ListEmployeesAccounts',
    component: EmployeeAccountList,
    module: 'employeeAccount',
    actions: ['view'],
    icon: Icons.FaUsers,
    label: 'Employee Accounts',
    group: 'accounts'
  },
  {
    path: '/AddAccount',
    component: AccountForm,
    module: 'companyAccount',
    actions: ['create'],
    icon: Icons.FaPlusCircle,
    label: 'Add Account',
    group: 'accounts'
  },
  {
    path: '/ExpenseManager',
    component: ExpenseManagement,
    module: 'companyAccount', // Reusing companyAccount for now or create a new permission
    actions: ['view', 'create'],
    icon: Icons.FaMoneyBillWave,
    label: 'Expense Manager',
    group: 'accounts'
  },

  // Payments
  {
    path: '/ListPayments',
    component: PaymentTransactionList,
    module: 'payments',
    actions: ['view'],
    icon: Icons.FaMoneyBillWave,
    label: 'Payments List',
    group: 'payments'
  },
  {
    path: '/AddPayments',
    component: PaymentForm,
    module: 'payments',
    actions: ['create'],
    icon: Icons.FaMoneyCheck,
    label: 'Add Payment',
    group: 'payments'
  },

  // Employee Management
  {
    path: '/ListAllEmployees',
    component: EmployeeList,
    module: 'employee',
    actions: ['view'],
    icon: Icons.FaUsers,
    label: 'Employees List',
    group: 'employees'
  },
  {
    path: '/AddEmployee',
    component: EmployeeForm,
    module: 'employee',
    actions: ['create'],
    icon: Icons.FaUserPlus,
    label: 'Add Employee',
    group: 'employees'
  },
  {
    path: '/edit-employee/:id',
    component: EmployeeForm,
    module: 'employee',
    actions: ['edit'],
    label: 'Edit Employee',
    group: 'employees'
  },
  {
    path: '/shift-management',
    component: ShiftManagement,
    module: 'employee',
    actions: ['view'], // Assuming Admin has view/manage permissions on employee module
    icon: Icons.FaClock,
    label: 'Shift Management',
    group: 'employees'
  },

  // Settings & System
  {
    path: '/CompanyProfile',
    component: CompanyProfile,
    module: 'settings',
    actions: ['view'],
    icon: Icons.FaBuilding,
    label: 'Company Profile',
    group: 'settings'
  },
  {
    path: '/AddCompany',
    component: CompanyForm,
    module: 'settings',
    actions: ['edit'],
    icon: Icons.FaEdit,
    label: 'Edit Company',
    group: 'settings'
  },
  {
    path: '/profile',
    component: UserProfile,
    module: 'users',
    actions: ['create'],
    icon: Icons.FaUsersCog,
    label: 'View User Profile',
    group: 'settings'
  },
  {
    path: '/InvoiceSettings',
    component: InvoiceSettings,
    module: 'settings',
    actions: ['edit'],
    icon: Icons.FaFileInvoiceDollar,
    label: 'Invoice Settings',
    group: 'settings'
  },
  {
    path: '/warranty-policies',
    component: PolicyManager,
    module: 'settings',
    actions: ['view', 'edit'],
    icon: Icons.FaShieldAlt,
    label: 'Warranty Policies',
    group: 'settings'
  },
  {
    path: '/SystemUsage',
    component: SystemUsage,
    module: 'settings',
    actions: ['view'],
    icon: Icons.FaHistory,
    label: 'System Data Usage',
    group: 'settings'
  },
  {
    path: '/SystemActivityLogs',
    component: SystemActivityLogs,
    module: 'settings',
    actions: ['view'],
    icon: Icons.FaHistory,
    label: 'Activity & Audit Logs',
    group: 'settings'
  },
  {
    path: '/GhostItemDetection',
    component: GhostItemDetection,
    module: 'settings',
    actions: ['view'],
    icon: Icons.FaHistory,
    label: 'Ghost Item Detection',
    group: 'settings'
  },
  {
    path: '/customer-device-hub',
    component: CustomerDeviceHub,
    module: 'customers',
    actions: ['view'],
    icon: Icons.FaMobileAlt,
    label: 'Device Hub',
    group: 'customers'
  },

  {
    path: '/UserProfiles',
    component: UserList,
    module: 'users',
    actions: ['view'],
    icon: Icons.FaUsersCog,
    label: 'User Profiles',
    group: 'settings'
  },

  {
    path: '/PermissionManager',
    component: PermissionManager,
    module: 'users',
    actions: ['edit'],
    icon: Icons.FaUserShield,
    label: 'Permissions',
    group: 'settings'
  },
  {
    path: '/new-device',
    component: DeviceCreationForm,
    module: 'users',
    actions: ['edit'],
    icon: Icons.FaUserShield,
    label: 'New Repair Device',
    group: 'settings'
  },
  {
    path: '/device-inspection',
    component: DeviceInspectionChecklist,
    module: 'users',
    actions: ['edit'],
    icon: Icons.FaUserShield,
    label: 'New Repair Device',
    group: 'settings'
  },
  {
    path: '/ticket',
    component: TicketManager,
    module: 'users',
    actions: ['edit'],
    icon: Icons.FaUserShield,
    label: 'New Repair Device',
    group: 'settings'
  },

  {
    path: '/service-items',
    component: QuickServiceManager,
    module: 'items',
    actions: ['view', 'edit'],
    icon: Icons.FaWrench,
    label: 'Quick Services',
    group: 'repair'
  },
  {
    path: '/phone-models',
    component: PhoneModelManager,
    module: 'users',
    actions: ['edit'],
    icon: Icons.FaUserShield,
    label: 'New Repair Device',
    group: 'settings'
  },
  {
    path: '/reported-issues',
    component: ReportedIssuesManager,
    module: 'users',
    actions: ['edit'],
    icon: Icons.FaUserShield,
    label: 'New Repair Device',
    group: 'settings'
  },
  {
    path: '/stocks-reports',
    component: StockReportOverview,
    module: 'users',
    actions: ['edit'],
    icon: Icons.FaUserShield,
    label: 'New Repair Device',
    group: 'settings'
  },
  {
    path: '/reports/portal',
    component: ReportsPortal,
    module: 'settings',
    actions: ['view'],
    icon: Icons.FaChartBar,
    label: 'Enterprise Intelligence',
    group: 'settings',
    requiredPlan: 'PRO',
    featureName: 'Forensic Intelligence'
  },
  {
    path: '/zakat-management',
    component: ZakatManager,
    module: 'zakat',
    actions: ['view', 'create'],
    icon: FaHandHoldingHeart,
    label: 'Zakat Management',
    group: 'settings'
  },
  {
    path: '/admin/quota',
    component: AdminQuotaHub,
    requiresSuperAdmin: true,
    icon: Icons.FaServer,
    label: 'Telecom Quota Hub',
    group: 'admin'
  },
  {
    path: '/admin/tenants',
    component: TenantRegistry,
    requiresSuperAdmin: true,
    icon: Icons.FaDatabase,
    label: 'Tenant Registry',
    group: 'admin'
  },
  {
    path: '/reports/profit-loss',
    component: ProfitLossReport,
    module: 'settings',
    actions: ['view'],
    icon: Icons.FaDollarSign,
    label: 'P&L Statement',
    group: 'settings',
    requiredPlan: 'PRO',
    featureName: 'Advanced Audit'
  },

  // Auth Routes
  {
    path: '/login',
    component: LoginForm,
    module: null,
    actions: [],
    icon: Icons.FaSignInAlt,
    label: 'Login',
    group: 'auth'
  },
  {
    path: '/Unauthorized',
    component: UnauthorizedPage,
    module: null,
    actions: [],
    icon: Icons.FaBan,
    label: 'Unauthorized',
    group: 'auth'
  }
];